import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import Link from '@cartwhl/common/components/Link';
import { Job, ProjectType } from '@cartwhl/common/types';
import { getHomepageUrl, getStudioUrl } from '@cartwhl/common/utils';
import DaysAgo from '@cartwhl/ui/atoms/DaysAgo';
import Text from '@cartwhl/ui/base/Text';
import ProjectCard from '@cartwhl/ui/feature/ProjectCard';
import Button from '@cartwhl/ui/input/Button';
import EmptyState from '@cartwhl/ui/messaging/EmptyState';

import { galleryStore, userStore } from 'stores/global';

import CurrentPlan from './CurrentPlan';
import GalleryList from './GalleryList';
import ProfileSection from './ProfileSection';

export default function Overview() {
  const { downloadHistory } = useSnapshot(userStore.state);
  const { favoritesRecords } = useSnapshot(galleryStore.state);

  const records = (favoritesRecords.data?.items || []) as Job[];

  useEffect(() => {
    if (records.length === 0 && favoritesRecords.status === 'initial') {
      galleryStore.fetchFavorites(8, false);
    }
    if (downloadHistory.status === 'initial') {
      userStore.fetchDownloadHistory({ limit: 6, sortAscending: false });
    }
  }, [records.length, favoritesRecords.status, downloadHistory]);

  return (
    <div className="overview max-w-(--breakpoint-md) mx-auto">
      <ProfileSection title="Your plan" boxed={false} className="mt-8">
        <CurrentPlan />
      </ProfileSection>
      <ProfileSection
        title="Recent favorites"
        boxed={false}
        className="mt-8"
        actions={
          <Link href={getHomepageUrl('/profile/favorites')}>
            <Button variant="tertiary">View All</Button>
          </Link>
        }
      >
        <GalleryList
          asyncState={favoritesRecords}
          variant="grid"
          maxRecords={4}
          onCardRender={(job: Job) => (
            <p>
              <Text
                variant="web/body/md"
                className="opacity-50 dark:opacity-70"
              >
                <DaysAgo date={job.createdAt} />
              </Text>
            </p>
          )}
        />
      </ProfileSection>

      <ProfileSection
        title="Recent downloads"
        boxed={false}
        className="mt-8"
        actions={
          <Link href={getHomepageUrl('/profile/download-history')}>
            <Button variant="tertiary">View All</Button>
          </Link>
        }
      >
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:px-0">
          {downloadHistory.data && downloadHistory.data.items.length > 0 ? (
            <>
              {downloadHistory.data.items.map((item) => (
                <ProjectCard
                  key={item.projectID}
                  title={item.projectName}
                  type={
                    item.projectType === ProjectType.MOTION ? 'animate' : 'pose'
                  }
                  href={`${getStudioUrl()}${
                    item.projectType === ProjectType.MOTION
                      ? `/motion/${item.projectID}`
                      : `/pose/${item.projectID}`
                  }
                  `}
                  preview={item.mp4Path}
                  lastUpdatedAt={item.dateRequested}
                />
              ))}
            </>
          ) : (
            <EmptyState
              className="col-span-full"
              description="No downloads found"
            />
          )}
        </div>

        {/* <GalleryList
          asyncState={{
            status: downloadHistory.status === 'pending' ? 'pending' : 'ready',
            data: {
              items: downloadHistory.data?.items.map(convertToJobLike) as Job[],
            },
          }}
          variant="grid"
          maxRecords={4}
          onCardRender={(job: Job) => (
            <p>
              <Text
                variant="web/body/md"
                className="opacity-50 dark:opacity-70"
              >
                {job.sessionName}
              </Text>
            </p>
          )}
        /> */}
      </ProfileSection>
    </div>
  );
}
